import api from '../api/axios'
import { DatosFichaTeletrabajo, DiaHabil, Domicilio, FichaTeletrabajo, PersonaTeletrabajo, SemanaGuias } from '../types/inventario'

/** Teletrabajo: fichas y guías de despacho (api/teletrabajo_views.py). Solo para quien administra bienes. */
export const teletrabajoService = {
  vigentes: async (): Promise<FichaTeletrabajo[]> => (await api.get<FichaTeletrabajo[]>('teletrabajo/')).data,
  delBien: async (bien: number): Promise<{ vigente: FichaTeletrabajo | null; anteriores: FichaTeletrabajo[] }> =>
    (await api.get(`bienes/${bien}/teletrabajo/`)).data,
  crear: async (bien: number, datos: DatosFichaTeletrabajo): Promise<FichaTeletrabajo> =>
    (await api.post<FichaTeletrabajo>(`bienes/${bien}/teletrabajo/`, datos)).data,
  editar: async (id: number, datos: Partial<Domicilio> & { dias?: DiaHabil[]; observacion?: string }): Promise<FichaTeletrabajo> =>
    (await api.patch<FichaTeletrabajo>(`teletrabajo/${id}/`, datos)).data,
  terminar: async (id: number, motivo = ''): Promise<FichaTeletrabajo> =>
    (await api.post<FichaTeletrabajo>(`teletrabajo/${id}/terminar/`, { motivo })).data,
  /** `semana`: cualquier día de la semana (AAAA-MM-DD). */
  guias: async (semana: string): Promise<SemanaGuias> => (await api.get<SemanaGuias>('teletrabajo/guias/', { params: { semana } })).data,
  /** Solo personas con cuenta en la app, con su domicilio. */
  personas: async (q: string): Promise<PersonaTeletrabajo[]> => (await api.get<PersonaTeletrabajo[]>('teletrabajo/personas/', { params: { q } })).data,
}
